module.exports = __webpack_public_path__ + "static/rollo-vietnamita-1-de50ddaa57b39fefb8e1f9076a870e84.jpg";